import { useProposalState, useOptionsState } from '@src/shared/hooks';
import { setTerms, setPrivatePolicy } from '@src/shared/zustand';
import { useState } from 'react';

export const useModalControls = () => {
  const [more, setMore] = useState(false);
  const [openModelMoreDetails, setOpenModelMoreDetails] = useState(false);
  const { loading } = useProposalState();
  const { terms, privatePolicy } = useOptionsState();

  const onClickMoreOptions = () => {
    if (!loading) setMore((old) => !old);
  };

  return {
    more,
    setMore,
    onClickMoreOptions,
    terms,
    setTerms,
    privatePolicy,
    setPrivatePolicy,
    openModelMoreDetails,
    setOpenModelMoreDetails,
  };
};
